export default "__VITE_ASSET__mOo4rCQY__"